export function WeighingStateBadge({ state }: { state: string }) {
  const styles: Record<string, string> = {
    draft: "bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300",
    signed_off:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
    superseded: "bg-muted text-muted-foreground",
  };
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold tracking-wider uppercase ${
        styles[state] ?? "bg-muted text-muted-foreground"
      }`}
    >
      {state.replace("_", " ")}
    </span>
  );
}
